var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoReviews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.09 244.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:gray;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Carita triste") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.34,1096.23H515.1a74.42,74.42,0,0,0-74.42,74.43v95.24a74.42,74.42,0,0,0,74.42,74.42h95.24a74.42,74.42,0,0,0,74.43-74.42v-95.24A74.43,74.43,0,0,0,610.34,1096.23ZM660.45,1267a49,49,0,0,1-49,49H514a49,49,0,0,1-49-49v-97.48a49,49,0,0,1,49-49h97.48a49,49,0,0,1,49,49Z",
    transform: "translate(-440.68 -1096.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.71,1289.14a49.08,49.08,0,0,1,47.14,0,11.93,11.93,0,0,0,14.14-2.11h0a12,12,0,0,0-3-19.17,74.56,74.56,0,0,0-69.45-.05,12,12,0,0,0-3,19.18h0A11.92,11.92,0,0,0,538.71,1289.14Z",
    transform: "translate(-440.68 -1096.23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.82,1189.16a8.87,8.87,0,0,1,7.71,13.33,25.86,25.86,0,0,1-44.32,0,8.87,8.87,0,0,1,7.71-13.33Z",
    transform: "translate(-440.68 -1096.23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M534.53,1189.61a8.87,8.87,0,0,1,7.71,13.33,25.87,25.87,0,0,1-44.33,0,8.87,8.87,0,0,1,7.71-13.33Z",
    transform: "translate(-440.68 -1096.23)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReviews);
export default __webpack_public_path__ + "static/media/noReviews.5494aa6e69de744a773dab70b7e900c4.svg";
export { ForwardRef as ReactComponent };